import { render, staticRenderFns } from "./Catetype.vue?vue&type=template&id=a667ca26&scoped=true"
import script from "./Catetype.vue?vue&type=script&lang=js"
export * from "./Catetype.vue?vue&type=script&lang=js"
import style0 from "./Catetype.vue?vue&type=style&index=0&id=a667ca26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a667ca26",
  null
  
)

export default component.exports